import React, { useEffect } from 'react'
import { Button } from '../../components/Button/Button'
import classes from './css/SectionTwo.module.css'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Aos from 'aos'
import "aos/dist/aos.css"

export const SectionTwo: React.FC = () => {
    const matches = useMediaQuery('(max-width:1094px)')
    useEffect(()=>{
        Aos.init({duration: 1300, once: false})
  
      },[])
    return (
    <section className={classes.SectionTwo} >
        {matches ? null : <div className={classes.first} data-aos="fade-up"/>}
        
        <div className={classes.second} data-aos="fade-up">
            <h1 className={classes.title}>عن الخدمة للموظفين</h1>
            {matches ? <div className={classes.first} /> : null}
            <div dir="rtl" className={classes.employee} data-aos="fade-up">
                <ul>
                    <li>يمكنك البحث بسهولة عن الوظيفة المطلوبة</li>
                    <li>يمكنك التقديم علي الوظيفة من منزلك</li>
                    <li>يمكنك متابعة طلب التقديم وموعد المقابلة الشخصية</li>
                    <li>اعرف اكتر عن احتياجات سوق العمل داخل مدينة السادات</li>
                </ul>
            </div>
            <div className={classes.btnsDiv} data-aos="fade-up">
                <Button to='/register/employee' width={200} height={45}>التسجيل كباحث عن عمل</Button>
                <p>أو</p>
                <Button to='/jobs' width={200} height={45}>الوظائف المتاحة</Button>
            </div>
        </div>
    </section>
    )
}